import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { ContextMenuComponent } from '../../../shared/components/context-menu/context-menu.component';
import { SvgComponent } from '../../../shared/components/svg/svg.component';
import { ButtonDirective } from '../../../shared/directives/button.directive';
import { AccessItemCtaComponent } from '../access-item-cta/access-item-cta.component';
import { AccessItemHeaderComponent } from '../access-item-header/access-item-header.component';
import { AccessItemComponent } from '../access-item/access-item.component';
import { FontSelectionMenuComponent } from '../font-selection-menu/font-selection-menu.component';

@Component({
  selector: 'app-theme-font-family-item',
  imports: [
    AccessItemComponent,
    AccessItemHeaderComponent,
    AccessItemCtaComponent,
    ContextMenuComponent,
    ButtonDirective,
    SvgComponent,
    FontSelectionMenuComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './theme-font-family-item.component.html',
  styleUrl: './theme-font-family-item.component.scss',
})
export class ThemeFontFamilyItemComponent {
  fontFamily = input.required<string>();
  fontFamilyChange = output<string>();
  fontFamilyDisplay = computed(() => {
    const fontFamily = this.fontFamily();
    if (!fontFamily || fontFamily === 'AkkuratLL') {
      return 'Picflow Type';
    }
    return fontFamily;
  });
}
